/*
 * @Author: 李朋飞
 * @Date: 2021-12-09 14:39:27
 * @LastEditTime: 2021-12-17 17:49:58
 * @Description: 
 */
import UploadFile from './UploadFile.vue';

export default {
  install(Vue) {
    Vue.component('UploadFile', UploadFile);
  }
};


// WEBPACK FOOTER //
// ./src/components/UploadFile/index.js